import { reducer as formReducer } from 'redux-form';
import { connectRouter } from 'connected-react-router';
import { productReducer as products } from './modules/product';
import { checkoutPageReducer as checkoutPage } from './modules/checkoutPage';
import { paymentMethodUpdatePageReducer as paymentMethodUpdatePage } from './modules/paymentMethodUpdatePage';
import { usageReducer as usages } from './modules/usage';
import { usagesPageReducer as usagesPage } from './modules/pages/usagesPage';
import { groupMembershipReducer as groupMembership } from './modules/groupMembership';
import { fhirReducer as fhir } from './modules/fhir';
import { invoiceReducer as invoices } from './modules/invoices';
import { accountsPageReducer as accountsPage } from './modules/pages/accountsPage/';
import { accessControlPageReducer as accessControlPage } from './modules/pages/accessControlPage';
import { filesReducer as files } from './modules/files';
import { policiesReducer as policies } from './modules/policies';
import { projectsReducer as projects } from './modules/projects';
import { datasetsReducer as datasets } from './modules/datasets';
import { projectStatsReducer as projectStats } from './modules/projectStats';
import { filesPageReducer as filesPage } from './modules/pages/filesPage';
import { projectsPageReducer as projectsPage } from './modules/pages/projectsPage';
import { analyticsReducer as analytics } from './modules/analytics';
import { insightsReducer as insightsPage } from './modules/pages/insights';
import { invitationsReducer as invitations } from './modules/invitations';
import { clientsReducer as clients } from './modules/clients';
import { clientsPageReducer as clientsPage } from './modules/pages/clientsPage';
import { tasksReducer as tasks } from './modules/tasks';
import { tasksPageReducer as tasksPage } from './modules/pages/tasksPage';
import { groupsPageReducer as groupsPage } from './modules/pages/groupsPage';
import { configurationRequestReducer as configurationRequest } from './modules/configurationRequests';
import { apiKeysReducer as apiKeys } from './modules/apiKeys';
import { cohortsReducer as cohorts } from './modules/cohorts';
import { cohortsPageReducer as cohortsPage } from './modules/pages/cohortsPage';
import { educationContentReducer as educationContent } from './modules/educationContent';
import { geneSetsReducer as geneSets } from './modules/geneSets';
import { projectKnowledgeReducer as projectKnowledge } from './modules/pages/projectKnowledge';
import { genomicsReducer as genomics } from './modules/genomics';
import { surveysReducer as surveys } from './modules/surveys';
import { subjectSearchReducer as subjectSearch } from './modules/subjects';
import { customAppsReducer as customApps } from './modules/customApps';
import { ehrsReducer as ehrs } from './modules/ehrs';
import { notesReducer as notes } from './modules/notes';
import { projectTagsReducer as projectTags } from './modules/projectTags';

// Please keep these alphabetized for simpler debugging
const reducers = history => ({
  accessControlPage,
  accountsPage,
  analytics,
  apiKeys,
  checkoutPage,
  clients,
  clientsPage,
  cohorts,
  cohortsPage,
  configurationRequest,
  customApps,
  datasets,
  educationContent,
  ehrs,
  fhir,
  files,
  filesPage,
  form: formReducer,
  geneSets,
  genomics,
  groupMembership,
  groupsPage,
  insightsPage,
  invitations,
  invoices,
  notes,
  paymentMethodUpdatePage,
  policies,
  products,
  projects,
  projectKnowledge,
  projectsPage,
  projectStats,
  projectTags,
  router: connectRouter(history),
  subjectSearch,
  surveys,
  tasks,
  tasksPage,
  usages,
  usagesPage,
});

export default reducers;
